import React from 'react';
import { Box, Typography, Skeleton, Button } from '@mui/material';

interface CommentListProps {
    loadingComments: boolean;
    error: boolean;
    comments: any[];
    rootComments: any[];
    renderComment: (cmt: any) => React.ReactNode;
    tickets: any;
    scrollRef: React.RefObject<HTMLDivElement>;
    replyTo: number | null;
    isEditing: boolean;
    editingComment: any;
    onCancelReply: () => void;
    onCancelEdit: () => void;
    attachedFilesCount: number;
}

const CommentListSection: React.FC<CommentListProps> = ({
    loadingComments,
    error,
    comments,
    rootComments,
    renderComment,
    tickets,
    scrollRef,
    replyTo,
    isEditing,
    editingComment,
    onCancelReply,
    onCancelEdit,
    attachedFilesCount,
}) => {
    const getMaxHeight = () => {
        if (attachedFilesCount === 2) return 450;
        if (attachedFilesCount === 1) return 505;
        return 550;
    };

    return (
        <>
            <Box flex={1} p={3} sx={{ overflowY: 'auto', maxHeight: getMaxHeight() }}>
                {loadingComments ? (
                    [...Array(3)].map((_, index) => (
                        <Box key={index} mb={3}>
                            <Box display="flex" alignItems="center" mb={1}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Box ml={2}>
                                    <Skeleton variant="text" width={100} />
                                    <Skeleton variant="text" width={200} />
                                </Box>
                            </Box>
                            <Skeleton variant="rectangular" height={60} />
                        </Box>
                    ))
                ) : comments.length === 0 ? (
                    <Box textAlign="center" mt={6}>
                        <Typography variant="body2" color="text.secondary">
                            🎫 Este ticket fue creado el {new Date(tickets.date).toLocaleDateString()} por <b>{tickets.user_name}</b>.
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mt={1}>
                            Puedes dejar aquí tus dudas o comentarios.
                        </Typography>
                    </Box>
                ) : (
                    rootComments.map(cmt => renderComment(cmt))
                )}
                <div ref={scrollRef} />
            </Box>

            {replyTo !== null && (
                <Typography variant="body2" color="text.secondary" mb={1} ml={2}>
                    Respondiendo a comentario #{replyTo} &nbsp;
                    <Button size="small" onClick={onCancelReply}>Cancelar</Button>
                </Typography>
            )}
            {isEditing && editingComment && (
                <Typography variant="body2" color="text.secondary" mb={1} ml={2}>
                    Editando comentario #{editingComment.id_comment} &nbsp;
                    <Button size="small" onClick={onCancelEdit}>Cancelar</Button>
                </Typography>
            )}
        </>
    );
};

export default CommentListSection;
